
<div class="content-wrapper d-print-none">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">ManPower Requests</h4>
            <div style="background: #ECECEC;padding:30px;">
                <div nz-row [nzGutter]="8">
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Location">
                           <!-- Department  -->
                            <select class="form-control" required [(ngModel)]="selectedLocationId" name="selectedDepartmentId"
                              id="selectedDepartmentId"   (change)="onLocationChange($event)">
                              <option value="">-- Select Location --</option>
                              <option [value]="location.name" *ngFor="let location of Locations">{{location.name}}
                              </option>
                            </select>
                       
                    </nz-card>
                  </div>

                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Function">
                           <!-- Department  -->
                            <select class="form-control" required [(ngModel)]="selectedFunctionId" name="selectedLocationId"
                              id="selectedLocationId"   (change)="onFunctionChange($event)">
                              <option value="">-- Select Function --</option>
                              <option [value]="department.name" *ngFor="let department of Departments">{{department.name}}
                              </option>
                            </select>
                       
                    </nz-card>
                  </div>

                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Vacancy Status">
                           <!-- Department  -->
                    
                              <ng-select [(ngModel)]="typeOfVacancy" (ngModelChange)="onTypeOfVacancyChange($event)" id="typeOfVacancy" name="typeOfVacancy">
                                <ng-option *ngFor="let a of typeofvacancy"  [value]="a.vacancy">{{a.vacancy}}
                                  </ng-option>
                              </ng-select>
                           
                    </nz-card>
                  </div>

               
                </div>

              </div>

              <div class="table-responsive pt-3">

                <input type="button" value="Export To Excel" (click)="exportExcel()" class="btn-primary"/>
             
                <nz-table #ManPowerTable [nzData]="Requests" [nzPageSize]="50">
                  <thead>
    
                    <tr>
                      <th>
                        #
                      </th>
    
                      <th>
                        Request Date
                      </th>
    
                      <th>
                        Created By
                      </th>
    
                      <th>
                        Function
                      </th>
    
                      <th>
                        Location
                      </th>
    
                      <th>
                        Status
                      </th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of ManPowerTable.data; let i = index ;" (click)="openRecruitment(data)" class="clickable" >
    
                      <td>
                        {{i+1}}
                      </td>
                      <td>
                        {{ data.createdDate | date: 'dd MMMM yyy' }}
                      </td>
    
                      <td>
                        {{data.createdBy}}
                      </td>
    
                      <td>
                        {{data.requesterFunction}}
                      </td>

                      <td>
                        {{data?.location}}
                      </td>
    
                      <td>
                        <button [ngClass]="getStatusColor(data.vacancyStatus)"> {{data.vacancyStatus}}</button>
                      </td>
                      <td>
                    
                      </td>
                    </tr>
                  </tbody>
                </nz-table>
    
              </div>

              
          </div>
        </div>
      </div>
  
  
    </div>
  </div>

  

<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040" [nzVisible]="ViewManpowerRecruitment" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block" id="detailSection">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
            <div class="row">
                <div class="col">
                    <h5 class="card-title"> Recruitment Details</h5>
                </div>
                <div class="col">
                    <img src="../../../assets/images/holcim_logo_color.svg" alt="" srcset="" style="height: 30px;">
                </div>
            </div>


            <div class="card-body">

                <h5>RECRUITMENT DETAILS</h5>
                <br>
                <div class="row">

                    <div class="col">
                        <label><b>Vacancy Status</b></label>
                        <p>{{ UpdateRequest?.vacancyStatus }}</p>
                    </div>
                    
                </div>

                <div class="row" *ngIf="advertVisible">
                  <div class="col">
           
                    <label><b>Advert Start Date</b></label>
                    <p>{{ UpdateRequest?.advertStartDate | date: 'dd MMMM yyyy'}}</p>

                </div>

                <div class="col">
           
                  <label><b>Advert Start Message</b></label>
                  <p>{{ UpdateRequest?.advertStartMessage }}</p>
                  
              </div>
            </div>
            <div class="row" *ngIf="advertEndVisible">
              <div class="col">
                <label><b>Advert End Date</b></label>
                <p>{{ UpdateRequest?.advertEndDate | date: 'dd MMMM yyyy'}}</p>
            </div>
            <div class="col">
                <label><b>Advert End Message</b></label>
                <p>{{ UpdateRequest?.advertStartMessage }}</p>
            </div>
            </div>

            <div class="row" *ngIf="advertEndVisible">

            <div class="col">
                <label><b>Advert Duration</b></label>
                <p>{{ advertDuration}}</p>
            </div>
            </div>
                 
            </div>

        
     
            <div class="card-body">
                <div class="row" *ngIf="shortListingVisible">

                    <div class="col">
                        <label><b>Shortlisting Start Date</b></label>
                        <p>{{ UpdateRequest?.shortlistingStartDate | date: 'dd MMMM yyyy'}}</p>
                    </div>

                    <div class="col">
                        <label><b>Shortlisting Start Message</b></label>
                        <p>{{ UpdateRequest?.band }}</p>
                    </div>

                </div>

                <div class="row" *ngIf="shortListingEndVisible">

                    <div class="col">
                        <label><b>Shortlisting End Date</b></label>
                        <p>{{ UpdateRequest?.shortlistingEndDate | date: 'dd MMMM yyyy'}}</p>
                    </div>
                    <div class="col">
                        <label><b>Shortlisting End Message</b></label>
                        <p>{{ UpdateRequest?.location }}</p>
                    </div>


                </div>

                <div class="row" *ngIf="shortListingEndVisible">

                    <div class="col">
                        <label><b>ShortListing Duration</b></label>
                        <p>{{ shortListingDuration}}</p>
                    </div>
                </div>

                <div class="row" *ngIf="interviewVisible">

                    <div class="col">
                        <label><b>Interview Start Date</b></label>
                        <p>{{ UpdateRequest?.interviewStartDate | date: 'dd MMMM yyyy'}}</p>
                    </div>
                    <div class="col">
                        <label><b>Interview Start Message</b></label>
                        <p>{{ UpdateRequest?.interviewStartMessage }}</p>
                    </div>



                </div>
                <div class="row" *ngIf="interviewEndVisible">
                    <div class="col">
                        <label><b>Interview End Date</b></label>
                        <p>{{ UpdateRequest?.interviewEndDate | date: 'dd MMMM yyyy'}}</p>
                    </div>

                    <div class="col">
                        <label><b>Interview End Message</b></label>
                        <p>{{ UpdateRequest?.interviewEndMessage }}</p>
                    </div>

                </div>

                <div class="row" *ngIf="interviewEndVisible">
                    <div class="col">
                        <label><b>Interview Duration</b></label>
                        <p>{{ interviewDuration}}</p>
                    </div>

                </div>
                <div class="row" *ngIf="OfferProcessVisible">

                    <div class="col">
                        <label><b>Offer Process Start Date</b></label>
                        <p>{{ UpdateRequest?.offerProcessStartDate | date: 'dd MMMM yyyy' }}</p>
                    </div>

                    <div class="col">
                        <label><b>Offer Process Start Message</b></label>
                        <p>{{ UpdateRequest?.offerProcessMessage }}</p>
                    </div>
                </div>

                <div class="row" *ngIf="OfferProcessEndVisible">

                    <div class="col">
                        <label><b>Offer Process End Date</b></label>
                        <p>{{ UpdateRequest?.offerProcessEndDate | date: 'dd MMMM yyyy'}}</p>
                    </div>

                    <div class="col">
                        <label><b>Offer Process End Message</b></label>
                        <p>{{ UpdateRequest?.offerProcessEndMessage }}</p>
                    </div>
                </div>

                <div class="row" *ngIf="OfferProcessEndVisible">
                    <div class="col">
                        <label><b>Offer Process Duration</b></label>
                        <p>{{ OfferProcessDuration }}</p>
                    </div>
                </div>

                <div class="row" *ngIf="acceptOfferVisible">

                  <div class="col">
                      <label><b>Accept Offer Start Date</b></label>
                      <p>{{ UpdateRequest?.acceptanceDate | date: 'dd MMMM yyyy'}}</p>
                  </div>

                  <div class="col">
                      <label><b>Accept Offer  Message</b></label>
                      <p>{{ UpdateRequest?.acceptanceMessage }}</p>
                  </div>
              </div>

              <div class="row" *ngIf="acceptOfferVisible">

                <div class="col">
                    <label><b>First Name:</b></label>
                    <p>{{ UpdateRequest?.employedFirstname }}</p>
                </div>

                <div class="col">
                    <label><b>Last Name:</b></label>
                    <p>{{ UpdateRequest?.employedLastname }}</p>
                </div>
            </div>

            <div class="row" *ngIf="acceptOfferVisible">

                <div class="col">
                    <label><b>Other Name:</b></label>
                    <p>{{ UpdateRequest?.employedMiddleName}}</p>
                </div>

                <div class="col">
                    <label><b>Band:</b></label>
                    <p>{{ UpdateRequest?.employedGrade }}</p>
                </div>
            </div>

            </div>
          </div>
          <ng-template #footerTpl>
            <div style="float: right" class="d-print-none">

                 <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;" (click)="close()">Close</button>

            </div>


        </ng-template>
        </div> 
    </div> 
            
  
  